<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import ErrorAlert from '../../../components/errorAlert.vue';
import { toast, variants } from "@/helpers/toaster";

export default {
  page: {
    title: "Budžeti",
  },
  components: {PageHeader, Layout, ErrorAlert},
  props: {
  },
  data() {
    return {
      title: 'Budžeti',
      employeeQuery: '',
      pricelistsQuery: '',
      sortDesc: true,
      search: '',
      fields: [
        {key: 'employee.object_name', label: 'Objekat', sortable: false},
        {key: 'employee.object_code', label: 'Šifra', sortable: false},
        {key: 'budget', label: 'Budžet', sortable: false, editable: true},
      ],
      coeficient: {
        value: null,
        error: false,
        errorMessage: '',
      },
      selectedGroup: null,
      groups: [],
      budgets: [],
    }
  },
  watch: {
    selectedGroup(v) {
      if (!v) this.budgets = [];
      this.loadBudgets();
    },
  },
  computed: {
    computedGroups() {
      if (!this.groups) return [];

      return this.groups.map((g) => {
        return {
          value: g,
          text: g.name,
        }
      });
    },
    isSaveDisabled() {
      return !this.selectedGroup;
    },
    searchedBudgets () {
      return this.budgets.filter((budget) => {
        return budget.employee?.object_name?.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      await axios.get('/admin/groups').then(response => {
        this.groups = response.data;
      })
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    async loadBudgets() {
      if (this.selectedGroup == null) {
        this.budgets=[]
        return;
      }
      let url = `/admin/employees/budgets/${this.selectedGroup.id}`;

      this.$store.commit('loader/START_LOADING');
      await axios.get(url).then((response => {
        this.budgets = response.data;
      })).finally(() => this.$store.commit('loader/END_LOADING'));
    },
    async downloadBudgets() {
      if (!this.selectedGroup) {
        return;
      }

      this.$store.commit('loader/START_LOADING');
      
      try {
        const response = await axios.get(`/admin/employees/export-budgets/${this.selectedGroup.id}`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'budzeti.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje budžeta.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async save() {
      const data = this.budgets.map((l) => {
        return {
          id: l.id,
          employee_id: l.employee.id,
          budget: l.value || l.value === '' || l.value === 0 ? l.value : l.budget,
          group_id: this.selectedGroup.id,
        }
      });
      const req = {}
      data.forEach(f => req[f.employee_id]=f.budget);
      this.$store.commit('loader/START_LOADING');

      try {
        const response = await axios.patch(`/admin/employees/budgets/${this.selectedGroup.id}`, {budgets: req})

        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            let item = this.budgets.find((l) => l.em === response.data[i].item_id);
            if (!item.id) item.id = response.data[i].id;
          }
        }
        toast('Uspešno snimanje budžeta.', variants.SUCCESS)
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    setCoeficient() {
      if (this.coeficient.value === null || this.coeficient.value <= 0) {
        this.coeficient.errorMessage = 'Koeficijent mora biti veći od 0';
        this.coeficient.error = true;
        return;
      }
      this.budgets.forEach((l) => {
        if (l.value) {
            l.value = (l.value * this.coeficient.value).toFixed(2);
        }
        if (l.budget) {
          l.budget = (l.budget * this.coeficient.value).toFixed(2);
        }
      });
      this.coeficient.value = null;
      toast('Uspešno promenjen koeficijent. Kliknuti na "Snimi" da promena bude upisana.', variants.SUCCESS)
    },
    onBudgetEdit(item, value) {
      this.$set(item, 'value', value)
      this.$set(item, 'budget', value)
    },
  }
}
</script>

<template>
  <Layout>
    <error-alert />
    <PageHeader :title="title"/>
    <div class="row mb-2">
      <div class="col-12 col-md-6 d-flex">
        <label class="col-form-label mr-2" for="groups">Grupa:</label>
        <b-form-select id="groups" v-model="selectedGroup" :options="computedGroups">
          <template #first>
            <b-form-select-option :value="null" disabled>-- Izaberi grupu --</b-form-select-option>
          </template>
        </b-form-select>
        <!-- <VueBootstrapAutocomplete
          class="autocomplete mr-2"
          id="groups"
          :data="groups"
          v-model="groupQuery"
          :serializer="(item) => item.name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedGroup = $event"
        /> -->
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-9 d-flex align-items-center">
        <label class="col-form-label mr-2" for="input-1">Koeficijent:</label>
          <b-form-input
          id="input-1"
          min="0"
          v-model="coeficient.value"
          @input="coeficient.error = false"
          type="number"
          required
          style="width: 200px"
          :class="{ 'is-invalid': coeficient.error , 'ml-2': true}"
        ></b-form-input>
          <button class="btn btn-primary ml-2" @click="setCoeficient()" :disabled="!selectedGroup" >Primeni</button>
          <b-form-invalid-feedback v-if="coeficient.error"
          class="ml-2"
          style="width: 200px"
          >
            {{coeficient.errorMessage}}
          </b-form-invalid-feedback>
      </div>
      <div class="col-12 col-md-3 text-right">
        <b-dropdown right variant="primary" size="md" class="mr-2">
          <template slot="button-content">
            <i class="fas fa-file-download mr-1"></i>
            Preuzmi
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item :disabled="!selectedGroup" @click="downloadBudgets()">Budžeti - Excel</b-dropdown-item>
        </b-dropdown>
        <b-button type="button" variant="success" @click="save()" :disabled="isSaveDisabled">Snimi</b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="search-box chat-search-box mb-2">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="searchedBudgets" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
        >
          <template v-slot:cell(budget)="data">
            <div v-if="data.field.editable">
              <b-form-input v-model="data.value" @input="onBudgetEdit(data.item, data.value)" type="number" />
            </div>
            <div v-else>
              <h1>{{ data.value }}</h1>
            </div>
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  .autocomplete {
    width: 100%;
  }
</style>
